// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nFkyUb1GGFsyq9moqtDq {
  /* Level Currency Font Size */
  --jp-currency-position: absolute;
  --jp-currency-line-height: 1;
  --jp-currency-span-height: 1em;
  --jp-grand-currency-font-size: 14px;
  --jp-major-currency-font-size: 8px;
  --jp-minor-currency-font-size: 8px;
  --jp-font-family: 'Futura PT Cond';
  --jp-value-font-weight: 800;
  --jp-level-value-align: center;
  --jp-major-font-size: 26px;
  --jp-minor-font-size: 26px;
  --jp-grand-width: 338px;
  --jp-grand-height: 88px;
  /* Major sits in left column alongside minor (like minor/mini layout) */
}
.nFkyUb1GGFsyq9moqtDq div[data-type='levelsContainer'] {
  row-gap: 0;
}
.nFkyUb1GGFsyq9moqtDq div[data-level='grand'] {
  --jp-level-padding-top: 22px;
  --jp-currency-margin-left: 15px;
  /* Equal padding = number stays visually centered, currency doesn't overlap */
  --jp-level-value-padding-left: 35px;
  --jp-level-value-padding-right: 35px;
}
.nFkyUb1GGFsyq9moqtDq div[data-level='major'] {
  --jp-level-padding-top: 15px;
  --jp-major-width: 151px;
  --jp-major-height: 55px;
  --jp-major-font-size: var(--jp-minor-font-size);
  --jp-level-value-padding-left: 18px;
  --jp-level-value-padding-right: 18px;
  grid-column: auto;
  margin-left: 15px;
}
.nFkyUb1GGFsyq9moqtDq div[data-level='minor'] {
  --jp-level-padding-top: 15px;
  --jp-minor-width: 151px;
  --jp-minor-height: 55px;
  --jp-level-value-padding-left: 18px;
  --jp-level-value-padding-right: 18px;
  margin-right: 15px;
  margin-left: 0;
}
.nFkyUb1GGFsyq9moqtDq [data-currency-level] {
  left: 0;
}
.nFkyUb1GGFsyq9moqtDq div[data-type='panelIcon'] {
  max-width: 153px;
  max-height: 63px;
}
@media (max-width: 1025px) {
  .nFkyUb1GGFsyq9moqtDq {
    --jp-grand-font-size: 37px;
    --jp-major-font-size: 24px;
    --jp-minor-font-size: 24px;
    --jp-grand-width: 308px;
    --jp-grand-height: 80px;
    --jp-grand-currency-font-size: 13px;
  }
  .nFkyUb1GGFsyq9moqtDq div[data-type='panelIcon'] {
    max-width: 139px;
    height: 58px;
  }
  .nFkyUb1GGFsyq9moqtDq div[data-level='grand'] [data-currency-level='grand'] {
    padding-bottom: 2px;
  }
  .nFkyUb1GGFsyq9moqtDq div[data-level='major'] {
    --jp-level-padding-top: 13px;
    --jp-major-width: 138px;
    --jp-major-height: 50px;
  }
  .nFkyUb1GGFsyq9moqtDq div[data-level='minor'] {
    --jp-level-padding-top: 13px;
    --jp-minor-width: 138px;
    --jp-minor-height: 50px;
  }
}
@media (orientation: portrait) {
  .nFkyUb1GGFsyq9moqtDq {
    margin-bottom: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/PremiumLink/PremiumLink.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uEAAuE;AACzE;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,6EAA6E;EAC7E,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,+CAA+C;EAC/C,mCAAmC;EACnC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,mCAAmC;EACrC;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".premiumLinkTheme {\n  /* Level Currency Font Size */\n  --jp-currency-position: absolute;\n  --jp-currency-line-height: 1;\n  --jp-currency-span-height: 1em;\n  --jp-grand-currency-font-size: 14px;\n  --jp-major-currency-font-size: 8px;\n  --jp-minor-currency-font-size: 8px;\n  --jp-font-family: 'Futura PT Cond';\n  --jp-value-font-weight: 800;\n  --jp-level-value-align: center;\n  --jp-major-font-size: 26px;\n  --jp-minor-font-size: 26px;\n  --jp-grand-width: 338px;\n  --jp-grand-height: 88px;\n  /* Major sits in left column alongside minor (like minor/mini layout) */\n}\n.premiumLinkTheme div[data-type='levelsContainer'] {\n  row-gap: 0;\n}\n.premiumLinkTheme div[data-level='grand'] {\n  --jp-level-padding-top: 22px;\n  --jp-currency-margin-left: 15px;\n  /* Equal padding = number stays visually centered, currency doesn't overlap */\n  --jp-level-value-padding-left: 35px;\n  --jp-level-value-padding-right: 35px;\n}\n.premiumLinkTheme div[data-level='major'] {\n  --jp-level-padding-top: 15px;\n  --jp-major-width: 151px;\n  --jp-major-height: 55px;\n  --jp-major-font-size: var(--jp-minor-font-size);\n  --jp-level-value-padding-left: 18px;\n  --jp-level-value-padding-right: 18px;\n  grid-column: auto;\n  margin-left: 15px;\n}\n.premiumLinkTheme div[data-level='minor'] {\n  --jp-level-padding-top: 15px;\n  --jp-minor-width: 151px;\n  --jp-minor-height: 55px;\n  --jp-level-value-padding-left: 18px;\n  --jp-level-value-padding-right: 18px;\n  margin-right: 15px;\n  margin-left: 0;\n}\n.premiumLinkTheme [data-currency-level] {\n  left: 0;\n}\n.premiumLinkTheme div[data-type='panelIcon'] {\n  max-width: 153px;\n  max-height: 63px;\n}\n@media (max-width: 1025px) {\n  .premiumLinkTheme {\n    --jp-grand-font-size: 37px;\n    --jp-major-font-size: 24px;\n    --jp-minor-font-size: 24px;\n    --jp-grand-width: 308px;\n    --jp-grand-height: 80px;\n    --jp-grand-currency-font-size: 13px;\n  }\n  .premiumLinkTheme div[data-type='panelIcon'] {\n    max-width: 139px;\n    height: 58px;\n  }\n  .premiumLinkTheme div[data-level='grand'] [data-currency-level='grand'] {\n    padding-bottom: 2px;\n  }\n  .premiumLinkTheme div[data-level='major'] {\n    --jp-level-padding-top: 13px;\n    --jp-major-width: 138px;\n    --jp-major-height: 50px;\n  }\n  .premiumLinkTheme div[data-level='minor'] {\n    --jp-level-padding-top: 13px;\n    --jp-minor-width: 138px;\n    --jp-minor-height: 50px;\n  }\n}\n@media (orientation: portrait) {\n  .premiumLinkTheme {\n    margin-bottom: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"premiumLinkTheme": `nFkyUb1GGFsyq9moqtDq`
};
export default ___CSS_LOADER_EXPORT___;
